import { produce as applyImmutably } from 'immer';
import { handleActions } from 'redux-actions';
import { websocketActions } from '../../../../app/middleware/websocket/actions/websocket';
import { organizationActions } from '../actions/organization';
const { organizationV2Get, organizationV2GetSucceeded, organizationV2GetFailed, 
// @TODO: add call for feature flags https://dixa-product.atlassian.net/browse/TEAMS-3673
// organizationGetFeatureFlags,
// organizationGetFeatureFlagsSucceeded,
// organizationGetFeatureFlagsFailed,
organizationV2GetPresignedAvatarUrl, organizationV2GetPresignedAvatarUrlSucceeded, organizationV2GetPresignedAvatarUrlFailed, organizationV2UploadAvatar, organizationV2UploadAvatarSucceeded, organizationV2UploadAvatarFailed, organizationV2Edit, organizationV2EditSucceeded, organizationV2EditFailed, } = organizationActions;
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
    },
    organization: {
        name: '',
        avatar_url: '',
        id: '',
        created_at: '',
        trial_ended_at: 'null',
        subdomain: '',
        suspended: false,
        default_queue: '',
        default_outbound_number: null,
        timezone: null,
    },
};
// Reducer
export const organization = handleActions({
    [websocketActions.createFulfilled.type]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            draftState.organization = action.payload.params.organization;
        });
    },
    [organizationV2Get.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'loading';
        });
    },
    [organizationV2GetSucceeded.toString()]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'succeeded';
            draftState.organization = action.payload.organization;
        });
    },
    [organizationV2GetFailed.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'failed';
        });
    },
    [organizationV2GetPresignedAvatarUrl.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'loading';
        });
    },
    [organizationV2GetPresignedAvatarUrlSucceeded.toString()]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'succeeded';
        });
    },
    [organizationV2GetPresignedAvatarUrlFailed.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'failed';
        });
    },
    [organizationV2UploadAvatar.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'loading';
        });
    },
    [organizationV2UploadAvatarSucceeded.toString()]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'succeeded';
            draftState.organization.avatar_url = action.payload.updates.avatar_url;
        });
    },
    [organizationV2UploadAvatarFailed.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'failed';
        });
    },
    [organizationV2Edit.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'loading';
        });
    },
    [organizationV2EditSucceeded.toString()]: (state, action) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'succeeded';
            draftState.organization = action.payload;
        });
    },
    [organizationV2EditFailed.toString()]: (state) => {
        return applyImmutably(state, (draftState) => {
            draftState.meta.asyncStatus = 'failed';
        });
    },
}, initialState);
